const rutaInitialState = {
  ruta: {
    data: [],
    loading: false,
    error: false,
  },
};

export default rutaInitialState;
